module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#speaker",
      toString: function () {
        return this.url;
      }
    }